<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('queryJob.deliveryAgent')"
    :width="$selectByLang('400px', '430px')"
    :close-on-click-modal="false"
  >
    <el-form :label-width="$selectByLang('70px', '100px')" label-position="right">
      <el-form-item :label="$t('queryJob.deliveryAgent')+':'">
        <el-input
          v-model="deliveryRemark"
          type="textarea"
          :rows="5"
        />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="clickHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { batchUpdate } from '@/api/AirExport/airExportJob'

export default {
  name: 'DeliverAgentDialog',
  props: {
    visible: { type: Boolean, required: true },
    jobs: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      deliveryRemark: ''
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.deliveryRemark = ''
      }
    }
  },
  methods: {
    clickHandler() {
      if (!this.deliveryRemark) {
        this.$message.info(this.$t('queryJob.enterDeliveryAgent'))
        return
      }
      batchUpdate(this.jobs, { airSelectiveType: 'deliveryRemark' }).then(res => {
        for (const item of res.data) {
          const job = this.jobs.find(p => p.uuid === item.uuid)
          if (job) {
            job.deliveryRemark = item.deliveryRemark
            job.version = item.version
          }
        }
        this.innerVisible = false
      })
    }
  }
}
</script>
